import { useGameStore } from '../../store/gameStore';

function pressKey(code: string) {
  window.dispatchEvent(new KeyboardEvent('keydown', { code, bubbles: true }));
}

function releaseKey(code: string) {
  window.dispatchEvent(new KeyboardEvent('keyup', { code, bubbles: true }));
}

interface DpadBtnProps {
  code: string;
  label: string;
  className?: string;
}

function DpadBtn({ code, label, className = '' }: DpadBtnProps) {
  return (
    <button
      className={`select-none touch-none bg-gray-700 active:bg-gray-500 text-white font-bold rounded-lg flex items-center justify-center text-lg ${className}`}
      onPointerDown={(e) => {
        e.preventDefault();
        pressKey(code);
      }}
      onPointerUp={() => releaseKey(code)}
      onPointerLeave={() => releaseKey(code)}
      onContextMenu={(e) => e.preventDefault()}
    >
      {label}
    </button>
  );
}

export function VirtualDpad() {
  const phase = useGameStore((s) => s.phase);
  if (phase !== 'playing' && phase !== 'transitioning') return null;

  return (
    <div className="flex items-end gap-6 justify-center mt-4 pb-2 md:hidden">
      {/* D-pad */}
      <div className="flex flex-col items-center gap-1">
        <DpadBtn code="ArrowUp" label="↑" className="w-12 h-12" />
        <div className="flex gap-1">
          <DpadBtn code="ArrowLeft" label="←" className="w-12 h-12" />
          <DpadBtn code="ArrowDown" label="↓" className="w-12 h-12" />
          <DpadBtn code="ArrowRight" label="→" className="w-12 h-12" />
        </div>
      </div>
      {/* Action buttons */}
      <div className="flex flex-col gap-1">
        <DpadBtn code="Space" label="⎵" className="w-16 h-12 text-sm" />
        <DpadBtn code="Escape" label="ESC" className="w-16 h-12 text-xs" />
      </div>
    </div>
  );
}
